var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$root.isLoading())?_c('div',{staticClass:"loader loader-100vh"},[_c('center',[_c('i',{staticClass:"fas fa-spinner fa-3x rotate",on:{"click":function($event){_vm.$ss.loading = false;}}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }